/* eslint-disable max-len */
export const exchangeInfo = [
  {
    id: 1,
    title: 'Binance',
    standart: 'You can complete your API settings for Multisignals to communicate with your stock account in just a few minutes!',
    
  },
  {
    id: 2,
    title: 'OKX',
    standart: 'You can complete your API settings for Multisignals to communicate with your stock account in just a few minutes!',
  },
   {
    id: 3,
    title: 'Binance TR',
    standart: 'You can complete your API settings for Multisignals to communicate with your stock account in just a few minutes!',
  },
];
